import { createRouter, createWebHistory } from 'vue-router'

const HomeView = () => import('../views/HomeView.vue')
const CompanyCreate = () => import('../views/CompanyCreate.vue')
const CompanyUpdate = () => import('../views/CompanyUpdate.vue')
const CompanyDetail = () => import('../views/CompanyDetail.vue')
const CompanyList = () => import('../views/CompanyList.vue')
const ProjectList = () => import('../views/ProjectList.vue')
const ProjectDetail = () => import('../views/ProjectDetail.vue')
const ProjectUpdate = () => import('../views/ProjectUpdate.vue')
const CampaignUpdate = () => import('../views/CampaignUpdate.vue')
const CampaignDetail = () => import('../views/CampaignDetail.vue')
const BasetestList = () => import('../views/BasetestList.vue')
const BasetestDetail = () => import('../views/BasetestDetail.vue')
const BasetestCreate = () => import('../views/BasetestCreate.vue')
const BasetestUpdate = () => import('../views/BasetestUpdate.vue')
const BoreholeUpdate = () => import('../views/BoreholeUpdate.vue')
const DpshUpdate = () => import('../views/DpshUpdate.vue')
const CptUpdate = () => import('../views/CptUpdate.vue')
const TrialpitUpdate = () => import('../views/TrialpitUpdate.vue')
const ImagesUpdate = () => import('../views/ImagesUpdate.vue')
const PasswordRequest = () => import('../components/auth/PasswordRequest.vue')
const PasswordReset = () => import('../components/auth/PasswordReset.vue')
const UserDetail = () => import('../components/auth/UserDetail.vue')
const UserList = () => import('../components/auth/UserList.vue')
const UserLogin = () => import('../components/auth/UserLogin.vue')
const UserLogout = () => import('../components/auth/UserLogout.vue')
const UserProfile = () => import('../components/auth/UserProfile.vue')
const UserUpdate = () => import('../components/auth/UserUpdate.vue')
const NotFound = () => import('../views/NotFound.vue')

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    { path: '/', name: 'home', component: HomeView },

    // Company
    {
      path: '/company/',
      name: 'CompanyList',
      component: CompanyList
    },
    {
      path: '/company/create/',
      name: 'CompanyCreate',
      component: CompanyCreate
    },
    {
      path: '/company/:id/',
      name: 'CompanyDetail',
      component: CompanyDetail
    },
    {
      path: '/company/:id/update/',
      name: 'CompanyUpdate',
      component: CompanyUpdate
    },

    // Project
    {
      path: '/project/create/',
      name: 'ProjectCreate',
      component: ProjectUpdate
    },
    {
      path: '/project/:id/',
      name: 'ProjectDetail',
      component: ProjectDetail
    },
    {
      path: '/project/:id/update/',
      name: 'ProjectUpdate',
      component: ProjectUpdate
    },
    {
      path: '/project/',
      name: 'ProjectList',
      component: ProjectList
    },

    // Campaign
    {
      path: '/campaign/create/:project_id/',
      name: 'CampaignCreate',
      component: CampaignUpdate
    },
    {
      path: '/campaign/:id/',
      name: 'CampaignDetail',
      component: CampaignDetail
    },
    {
      path: '/campaign/:id/update/',
      name: 'CampaignUpdate',
      component: CampaignUpdate
    },

    // Basetest
    {
      path: '/basetest/',
      name: 'basetest-list',
      component: BasetestList
    },
    {
      path: '/basetest/:id/',
      name: 'BasetestDetail',
      component: BasetestDetail
    },
    {
      path: '/basetest/create/',
      name: 'BasetestCreate',
      component: BasetestCreate
    },
    {
      path: '/basetest/:id/update',
      name: 'BasetestUpdate',
      component: BasetestUpdate
    },
    {
      path: '/basetest/:id/update/borehole/',
      name: 'BoreholeUpdate',
      component: BoreholeUpdate
    },
    {
      path: '/basetest/:id/update/images/',
      name: 'ImagesUpdate',
      component: ImagesUpdate
    },
    {
      path: '/basetest/:id/update/dpsh/',
      name: 'DpshUpdate',
      component: DpshUpdate
    },
    {
      path: '/basetest/:id/update/cpt/',
      name: 'CptUpdate',
      component: CptUpdate
    },
    {
      path: '/basetest/:id/update/trialpit/',
      name: 'TrialpitUpdate',
      component: TrialpitUpdate
    },

    // Usuarios
    { path: '/auth/login', name: 'login', component: UserLogin },
    { path: '/auth/login', name: 'logout', component: UserLogout },
    { path: '/auth/user/', name: 'UserList', component: UserList },
    { path: '/auth/user/create', name: 'UserCreate', component: UserUpdate },
    { path: '/auth/profile', name: 'UserProfile', component: UserProfile },
    {
      path: '/auth/password-request',
      name: 'PasswordRequest',
      component: PasswordRequest
    },
    {
      path: '/auth/password-reset/:token/',
      name: 'PasswordReset',
      component: PasswordReset
    },
    {
      path: '/auth/user/:uid/update',
      name: 'UserUpdate',
      component: UserUpdate
    },
    { path: '/auth/user/:uid/', name: 'UserDetail', component: UserDetail },
    // Catch all route for 404 Page Not Found error
    { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFound }
  ]
})

export default router
